import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPeopleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 12.8a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4M16 4a5.6 5.6 0 1 1 0 11.2A5.6 5.6 0 0 1 16 4m-1.2 16a5 5 0 0 0-5.2 5.2v.8a1.2 1.2 0 1 1-2.4 0v-.8c0-4.2 3.4-7.6 7.6-7.6h2.4c4.2 0 7.6 3.4 7.6 7.6v.8a1.2 1.2 0 1 1-2.4 0v-.8c0-2.9-2.3-5.2-5.2-5.2zm6.8-4.7 1.4-1.9 1 .2a2.4 2.4 0 0 0 0-4.8l-.6-2.4h.6a4.8 4.8 0 1 1-2.4 9M8 6.4h.6L8 8.8a2.4 2.4 0 1 0 1 4.6l1.4 2q-1 .6-2.4.6a4.8 4.8 0 0 1 0-9.6m-.5 12a10 10 0 0 0-1.9 2.8A5 5 0 0 0 2.4 26 1.2 1.2 0 1 1 0 26c0-4.2 3.3-7.5 7.5-7.6m18.9 2.8q-.7-1.6-1.9-2.8c4.2 0 7.5 3.4 7.5 7.6a1.2 1.2 0 1 1-2.4 0q-.2-3.4-3.2-4.8" })
});
export default SvgPeopleRegularIcon;
